import styled from 'styled-components';
import { spacer40 } from '@spotify-internal/encore-web/core';
import { NavBarHeight } from '../../constants';
import { TIMEOUT_IN, TIMEOUT_OUT, flyoutTransitionMixin, } from '../../FlyoutMenu/config';
export const NavBarWrapper = styled.header `
  ${flyoutTransitionMixin('background-color', 'color', 'transform')};
  // This is faster than the rest of the flyout animations,
  // so that the background color goes away before the rest of the flyout.
  transition-duration: ${({ theme }) => theme.isFlyout ? TIMEOUT_IN : TIMEOUT_OUT / 3}ms !important;
  background-color: ${props => props.theme.isScrolling ? props.theme.background : 'transparent'};
  height: ${NavBarHeight}px;
  align-items: center;
  box-sizing: border-box;
  transition: background 300ms ease;
  color: ${props => props.theme.text};
  display: flex;
  justify-content: space-between;
  padding-block: 18px;
  padding-inline: ${spacer40};
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
`;
//# sourceMappingURL=index.js.map